























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { RouteConfig } from "vue-router";
import { AddPromotionRoute } from "../router";
import IView from "./IView";

@Component
export default class PromotionManagement extends Vue implements IView {
    @Prop({ required: true })
    title!: string;

    get addRoute(): RouteConfig {
        return AddPromotionRoute;
    }
}
